export const statusInscricao = {
  DEFERIDO: "DEFERIDO",
  INDEFERIDO: "INDEFERIDO",
  PENDENTE: "PENDENTE",
  DESISTENTE: "DESISTENTE",
  ELIMINADO: "ELIMINADO"
};
